export default "__VITE_ASSET__cc356b9e__"